<template>
  <div class="w-full text-center mt-4 line-height-default font-opacity-hg">
    <SmartIcon
      :size="4"
      type="big"
      name="warning"
      class="text-ui-warning"
    />
    <template v-if="filterCache">
      <h3 class="font-bold">
        Oh não! A pesquisa falhou!
      </h3>
      <h2 class="mt-1">
        Não encontramos {{ type }}
        <br/>com a pesquisa <strong>"{{ filterCache }}"</strong>!
      </h2>
    </template>
    <template v-else>
      <h3 class="font-bold">
        Que lugar mais silencioso...
      </h3>
      <h2 class="mt-1">
        Ainda não existem {{ type }}s
      </h2>
      <SmartButton
        class="mt-2"
        secondary
        @click="onButtonClick">
        Criar {{ type }}
      </SmartButton>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null
    },
    filter: {
      type: String,
      default: null
    },
    buttonAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      filterCache: this.filter
    };
  },
  methods: {
    onButtonClick(event) {
      this.$emit('buttonAction', event);
    }
  }
};
</script>
